import './index.css';
import logoSenado from '../../assets/logo-senado.svg';
import logoUnB from '../../assets/unb-logo.svg';
import seta from '../../assets/arrow-right.svg';
import setaCurvada from '../../assets/CURVED-ARROW.svg';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faBars} from '@fortawesome/free-solid-svg-icons';

export default function SobreProjeto ({ isOpen, onClose }) {
  const [paginaDois, setPaginaDois] = useState(false);
  if (!isOpen) return null;

  const openPagDois = () => {setPaginaDois(true); };
  const closePagDois = () => {setPaginaDois(false); };

  const close = () => {
    closePagDois();
    onClose();
  }

  if(paginaDois === false){
    return (
      <div className="sobre-fundo" id="sobre-fundo-1">
        <div>
          <p>Senado 200 anos é uma iniciativa conjunta da Universidade de Brasília e do Senado Federal para celebrar os 200 anos do Legislativo brasileiro.</p>
          <p>Este conteúdo foi produzido por professores e pesquisadores da UnB, com apoio da Consultoria Legislativa e da Secretaria de Comunicação Social. O objetivo é destacar a importância do Poder Legislativo na história do Brasil.</p>
          <p>Aqui você encontrará informações sobre a memória do Legislativo e seu papel essencial na construção da democracia no país.</p>
        </div>
        <div>
          <img src={logoSenado} alt="Logo do Senado" />
          <img src={logoUnB} alt="Logo da UnB" />
        </div>
        <button onClick={openPagDois} className="sobre-arrow" >
          <img src={seta} alt="seta para direita" />
        </button>
      </div>
    )
  }else{
    return (
      <div className="sobre-fundo" id="sobre-fundo-2">
        <div onClick={close}> <span>MENU</span> <FontAwesomeIcon icon={faBars} className="fabars-transition"/> </div>
        <img className="sobre-seta-curvada" src={setaCurvada} alt="seta curvada para cima" />
        <div className="sobre-texto" >Aqui você visualiza o <br/>Menu com nossos<br/>conteúdos</div>
      </div>
    )
  }
}